import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, mergeProps as _mergeProps, vShow as _vShow, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3c4e60a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block w-full" }
const _hoisted_2 = { class: "block w-full" }
const _hoisted_3 = { class: "gridTooltipButton tooltip infoIcon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-info" }, null, -1))
const _hoisted_5 = { class: "tooltiptext shadow" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_9 = { class: "inputTitle" }
const _hoisted_10 = { class: "inputField flex-grow" }
const _hoisted_11 = { class: "inputTitle" }
const _hoisted_12 = { class: "inputField flex-grow" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "None" }, "None", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "ApiKey" }, "ApiKey", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "OAuth2" }, "OAuth2", -1))
const _hoisted_16 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "inputTitle" }
const _hoisted_19 = { class: "inputField flex-grow" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "inputTitle" }
const _hoisted_22 = { class: "inputField flex-grow" }
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "inputTitle" }
const _hoisted_25 = { class: "inputField flex-grow" }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { class: "inputTitle" }
const _hoisted_28 = { class: "inputField flex-grow" }
const _hoisted_29 = { key: 4 }
const _hoisted_30 = { class: "inputTitle" }
const _hoisted_31 = { class: "inputField flex-grow" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { class: "grid grid-cols-2 gap-4 w-full" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-reset" }, null, -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1))
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = { class: "block w-full" }
const _hoisted_46 = { class: "block w-full" }
const _hoisted_47 = { class: "gridTooltipButton tooltip infoIcon" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-info" }, null, -1))
const _hoisted_49 = { class: "tooltiptext shadow" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = {
  key: 0,
  class: "smallText"
}
const _hoisted_53 = { class: "block w-full" }
const _hoisted_54 = { class: "flex mb-4" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1))
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "ml-auto" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "text-center" }

import { onMounted, onBeforeUnmount, reactive, ref, computed } from "vue";
    import { BryntumGrid } from "@bryntum/grid-vue-3";
    import { Store, Menu } from "@bryntum/grid";
    import { PermissionService } from "@/utilities/services/PermissionService";
    import ErrorHandler from "@/utilities/helpers/ErrorHandler";
    import GridInputFilter from "@/components/GridInputFilter.vue";
    import { WebhookService } from "@/utilities/services/entities/WebhookService";
    import type { Subscriber } from "@/models/webhook/Subscriber";
    import type { Subscription } from "@/models/webhook/Subscription";
    import type { SubscriptionInfo } from "@/models/webhook/SubscriptionInfo";
    import { SingleResponse, ListResponse, GeneralResponse, WebhookIdentifierResponse } from "@/models/api/Responses";
    import { useGlobalStore } from "@/stores/GlobalStore";
    import { ErrorLocationType, PopupType, TableType } from "@/utilities/enums/Enums";
    import dialog from "@/dialog";
    import { useI18n } from "vue-i18n";
    import { checkboxColumnConfig, defaultSpaceAroundTableOnPage } from "@/AppConfig";
    import LoadingSpinner from "@/components/LoadingSpinner.vue";



    
export default /*#__PURE__*/_defineComponent({
  __name: 'Webhook',
  setup(__props) {

    const permissionService = new PermissionService();
    let selectedSubscription = ref([]);
    const service = new WebhookService();
    const { t } = useI18n();
    const globalStore = useGlobalStore();

    const gridStore = new Store();
    const grid = ref(null);
    const currentWindowHeight = ref("");
    const recalcGridHeight = () => {
        currentWindowHeight.value = `${window.innerHeight - defaultSpaceAroundTableOnPage}px`;
    };

    const useGridConfig = {
        height: currentWindowHeight,
        headerMenuFeature: false,
        relayStoreEvents: true,
        enableTextSelection: true,
        selectionMode: {
            row: true,
            checkbox: checkboxColumnConfig,
            showCheckAll: true,
            deselectFilteredOutRecords: true
        },
        columns: {
            data: [
                { id: "eventType", field: "eventType", text: t("webhook.eventType"), flex: 1 },
                {
                    id: 'menu',
                    text: '',
                    width: 36,
                    type: 'widget',
                    align: "center",
                    hideable: false,
                    resizable: false,
                    sortable: false,
                    filterable: false,
                    widgets: [{
                        type: 'button',
                        width: 36,
                        icon: 'icon-kontext_horizontal',
                        onAction: ({ source: btn }: { source: any }) => {
                            const menu = menuFactory(btn.cellInfo.record.data);
                            menu.alignTo({ target: btn })
                            menu.show();
                        }
                    }]
                },
            ],
            listeners: {
                async add(event: any) {
                    if (event.records.length === 1 && event.isMove[event.records[0].id]) {
                        await globalStore.saveUserColumnOrder(TableType[TableType.subscription], event.records[0].id, event.index.toString());
                    }
                },
            }
        },
        store: gridStore,
        listeners: {
            selectionChange(event: any) {

                if (event.selection.length > 0 && event.selection[0]?.data === undefined) return;
                selectedSubscription.value = selectedSubscription.value.concat(event.selected.map(rr => rr.data))
                selectedSubscription.value = selectedSubscription.value.filter(r => !event.deselected.map(rr => rr.data).some(rr => r?.id === rr?.id));

            },
            datachange() {
                globalStore.currentItems = gridStore.count;
                globalStore.allItems = gridStore.originalCount;
            }
        },

    }
    const gridConfig = reactive(useGridConfig);
    const menuFactory = (record: any) => {
        const menu = new Menu({
            anchor: true,
            autoShow: true,
            items: [
                {
                    text: t('global.edit'),
                    cls: 'color',

                    icon: 'icon-editieren',
                    hidden: !permissionService.userHasPermission("Webhook.Edit"),
                    weight: 100,
                    onItem: ({ menu }: any) => {
                        openEdit(menu.record.id);
                    }
                },
                {
                    text: t('global.delete'),
                    hidden: !permissionService.userHasPermission("Webhook.Delete"),
                    cls: 'color',
                    icon: 'icon-loeschen',
                    weight: 140,
                    onItem: async ({ menu }: any) => {
                        const answer = await dialog
                            .okText(t("global.delete"))
                            .cancelText(t("global.cancel"))
                            .confirm(t("webhook.confirmDeletionSingleSubscription", { name: menu.record.eventType }));

                        if (!answer) return;

                        if (answer) {
                            const resp = await service.deleteSubscription(menu.record.id);

                            if (resp === null || resp === undefined || resp?.statusCode !== 0) {
                                ErrorHandler.handleError(resp, ErrorLocationType.form);
                                return;
                            }
                        }
                        gridStore.applyChangeset({ removed: [{ id: menu.record.id }] });

                        globalStore.showSuccess(t('webhook.subscriptionDeleted'));

                    }
                }
            ],
        });

        menu.record = record;

        return menu;
    };

    const deleteSelected = async () => {
        if (!selectedSubscription.value?.some(() => true)) return;

        const answer = await dialog
            .okText(t('global.delete'))
            .cancelText(t('global.cancel'))
            .confirm(t('webhook.confirmDeletionMulti', { id: selectedSubscription.value.length }));

        if (answer) {
            let someEntriesFailed = false;
            for (const subscription of selectedSubscription.value) {
                const resp = await service.deleteSubscription(subscription.id);

                if (resp === null || resp === undefined || resp?.statusCode !== 0) {
                    ErrorHandler.handleError(resp, ErrorLocationType.table);
                    someEntriesFailed = true;
                    continue;
                }

                gridStore.applyChangeset({ removed: [{ id: subscription.id }] });

            }

            if (someEntriesFailed) return;

            globalStore.showSuccess(t("webhook.subscriptionDeleted"));
        }
    };

    // ---- state
    const subscriber = ref<Subscriber>({
        id: null,
        name: "systemSubscriber",
        authType: "None",
        apiKey: null,
        oAuthTokenEndpoint: null,
        oAuthClientId: null,
        oAuthClientSecret: null,
        oAuthScope: null
    });
    const producerId = "00000000-0000-0000-0000-000000000000";
    const subscriptions = ref<SubscriptionInfo[]>([]);
    const loadingSubs = ref<boolean>(false);
    const thereIsSubscriber = computed(() => subscriber?.value?.id);

    const ctxMenu = reactive<{ show: boolean; rowId: number | null; x: number; y: number }>({
        show: false,
        rowId: null,
        x: 0,
        y: 0
    });

    // ---- load
    const loadubscriber = async () => {

        const idResp = (await service.getIdentifier()) as WebhookIdentifierResponse;
        const subId = idResp?.id || null;

        if (subId) {
            const respSubscriber = (await service.getSubscriber()) as SingleResponse<Subscriber>;
            if (respSubscriber && respSubscriber.statusCode == 0 && respSubscriber.value) {
                subscriber.value = respSubscriber.value;
            }
        }

    };


    const loadSubscriptions = async () => {
        loadingSubs.value = true;
        const respf = await service.getAllSubscriptions();
        const resp = (respf) as ListResponse<SubscriptionInfo>;

        if (resp && resp.statusCode === 0) {
            subscriptions.value = resp.value ?? [];
            gridStore.data = subscriptions.value;
        } else {
            subscriptions.value = [];
        }
        loadingSubs.value = false;
    };

    // support a mixed backend (wrapped or raw dto)
    const loadSubscriptionById = async (id: number): Promise<Subscription | null> => {
        const resp: any = await service.getSubscriptionById(id);
        if (resp?.statusCode !== undefined) {
            if (resp.statusCode !== 0) return null;
            return resp.value ?? null;
        }
        return resp as Subscription;
    };
    const cleanUpSubsciber = () => {
        if (subscriber.value.authType !== "ApiKey")
            subscriber.value.apiKey = null;
        if (subscriber.value.authType !== "OAuth2") {
            subscriber.value.oAuthTokenEndpoint = null;
            subscriber.value.oAuthClientId = null;
            subscriber.value.oAuthClientSecret = null;
            subscriber.value.oAuthScope = null;
        }
    };

    // ---- subscriber save
    const UpdateSubscriber = async () => {
        try {
            globalStore.gridDataIsLoading = true;
            cleanUpSubsciber();
            const payloadSubscriber: Subscriber = JSON.parse(JSON.stringify(subscriber.value));
            if (thereIsSubscriber.value) {
                const resp = (await service.updateSubscriber(payloadSubscriber)) as GeneralResponse;
                if (resp && resp.statusCode === 0) {
                    globalStore.showSuccess(t("webhook.subscriberUpdated"));
                }
            }
        } finally {
            globalStore.gridDataIsLoading = false;
        }
    };
    const createIfNotExisitSubscriber = async () => {
        try {
            globalStore.gridDataIsLoading = true;

            const idResp = (await service.getIdentifier()) as WebhookIdentifierResponse;
            const subId = (idResp != null) ? idResp?.id : null;
            if (subId) {
                if (!thereIsSubscriber.value) {
                    const resp = await createSubscriber(subId);
                    if (resp && resp.statusCode === 0) {
                        await loadubscriber();
                    }
                }
                            globalStore.showSuccess(t("webhook.subscriberProducerCreated"));
            }

        }
        finally {
            globalStore.gridDataIsLoading = false;
        }
    };

    const createSubscriber = async (idParam: any) => {
        cleanUpSubsciber();
        const subscriberPayload = JSON.parse(JSON.stringify(subscriber?.value));
        subscriberPayload.id = idParam;
        const resp = (await service.createSubscriber(subscriberPayload)) as SingleResponse<number>;
        if (resp && resp.statusCode === 0 && resp.value) {
            subscriber.value.id = idParam;
        }
        return resp;
    };

    // ---- popup open/create/update
    const openCreate = () => {
        const dto = getDefaultSubscriptionInfo();

        globalStore.openPopup({
            data: dto,
            action: createSubScription,
            resetButton: false,
            title: t("webhook.createSubscription"),
            type: PopupType.WebhookNewSubscriptionPopup
        });
    };

    const createSubScription = async () => {
        const dto = globalStore.modal.contentObject as SubscriptionInfo & { userInfo?: string | null };
        const resp = (await service.createSubscription(dto)) as GeneralResponse;

        if (resp && resp.statusCode === 0) {
            globalStore.closeModal();
            await loadSubscriptions();
            globalStore.showSuccess(t("webhook.createSubscription"));
        } else {
            (globalStore.modal.contentObject as any).userInfo = t(`error.status.${resp.statusCode}`) || "Error";

        }
    };

    const openEdit = async (id: number) => {
        closeRowMenu();
        const baseDto = getDefaultSubscriptionInfo();
        baseDto.id = id;

        const existing = await loadSubscriptionById(id);
        if (existing) {
            baseDto.eventType = existing.eventType ?? baseDto.eventType;
            baseDto.producerName = existing.producerName ?? baseDto.producerName;
            // producerId isn't returned by GET; user fills it
        }

        globalStore.openPopup({
            data: existing,
            action: updateSubScription,
            resetButton: false,
            title: t("webhook.updateSubscription"),
            type: PopupType.WebhookUpdateSubscriptionPopup
        });
    };

    // ---- row menu


    const closeRowMenu = () => {
        ctxMenu.show = false;
        ctxMenu.rowId = null;
    };

    // ---- update
    const updateSubScription = async () => {
        const editId = ((globalStore.modal.contentObject as any)?.id as number) || 0;
        if (!editId) return;

        const dto = globalStore.modal.contentObject as SubscriptionInfo & { userInfo?: string | null };
        const resp = (await service.updateSubscription(editId, dto)) as GeneralResponse;

        if (resp && resp.statusCode === 0) {
            globalStore.closeModal();
            await loadSubscriptions();
            globalStore.showSuccess(t("webhook.updateSubscription"));
        } else {
            (globalStore.modal.contentObject as any).userInfo = t(`error.status.${resp.statusCode}`)  || "Error";

        }
    };

    // ---- defaults for popup dto
    const getDefaultSubscriptionInfo = (): (SubscriptionInfo & { userInfo?: string | null; id?: number }) => ({
        // id undefined for create
        subscriberId: subscriber.value?.id || "",
        subscriberName: subscriber.value?.name || "",
        producerId: producerId,
        producerName: "",
        eventType: "",
        targetUrl: "",
        httpMethod: "POST",
        headers: {},
        payloadTemplate: "",
        contentType: "application/json",
        authType: "None",
        apiKey: null,
        oAuthTokenEndpoint: null,
        oAuthClientId: null,
        oAuthClientSecret: null,
        oAuthScope: null
    });

    // ---- delete
    const removeSubscription = async (id: number | undefined | null) => {
        if (!id) return;

        const answer = await dialog
            .okText(t("global.delete"))
            .cancelText(t("global.cancel"))
            .confirm(t("webhook.confirmDeletionSingleSubscription", { name: id }));

        if (!answer) return;

        const resp = (await service.deleteSubscription(id)) as GeneralResponse;
        if (resp && resp.statusCode === 0) {
            await loadSubscriptions();
            globalStore.showSuccess(t("webhook.subscriptionDeleted"));
        }
    };

    onMounted(async () => {
        globalStore.gridDataIsLoading = true;
        recalcGridHeight();
        window.addEventListener('resize', recalcGridHeight);





        await loadubscriber();
        await loadSubscriptions();
        await setGridData();
        globalStore.gridDataIsLoading = false;

    });
    const setGridData = async () => {
        // start spinner
        globalStore.gridDataIsLoading = true;

        const subscriptionsAll = await service.getAllSubscriptions();

        if (subscriptionsAll === null || subscriptionsAll === undefined || subscriptionsAll.statusCode !== 0) {
            ErrorHandler.handleError(subscriptionsAll, ErrorLocationType.form);
            return;
        }

        gridStore.data = (subscriptionsAll.value);
        globalStore.reorderColumns(TableType[TableType.subscription]);

        globalStore.closeModal();
        // stop spinner
        globalStore.gridDataIsLoading = false;
    };
    onBeforeUnmount(() => {
        window.removeEventListener("resize", recalcGridHeight);
        document.removeEventListener("click", closeRowMenu);
    });



return (_ctx: any,_cache: any) => {
  const _component_WebhookNewSubscriptionPopup = _resolveComponent("WebhookNewSubscriptionPopup")!
  const _component_WebhookUpdateSubscriptionPopup = _resolveComponent("WebhookUpdateSubscriptionPopup")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h4", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('webhook.subscriber')) + " ", 1),
              _createElementVNode("span", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("span", _hoisted_5, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.$t('webhook.subscriberInfoTitle')), 1),
                  _hoisted_6,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('webhook.subscriberInfo')), 1)
                ])
              ])
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('webhook.subscriberName')), 1),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control w-full",
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subscriber.value.name) = $event))
                  }, null, 512), [
                    [_vModelText, subscriber.value.name]
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('webhook.authType')), 1),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-control w-full",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subscriber.value.authType) = $event))
                  }, _hoisted_16, 512), [
                    [_vModelSelect, subscriber.value.authType]
                  ])
                ])
              ]),
              (subscriber.value.authType === 'ApiKey')
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('webhook.apiKey')), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control w-full",
                        type: "text",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((subscriber.value.apiKey) = $event))
                      }, null, 512), [
                        [_vModelText, subscriber.value.apiKey]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (subscriber.value.authType === 'OAuth2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('webhook.oAuthTokenEndpoint')), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control w-full",
                        type: "text",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((subscriber.value.oAuthTokenEndpoint) = $event))
                      }, null, 512), [
                        [_vModelText, subscriber.value.oAuthTokenEndpoint]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (subscriber.value.authType === 'OAuth2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('webhook.oAuthClientId')), 1),
                    _createElementVNode("div", _hoisted_25, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control w-full",
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((subscriber.value.oAuthClientId) = $event))
                      }, null, 512), [
                        [_vModelText, subscriber.value.oAuthClientId]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (subscriber.value.authType === 'OAuth2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('webhook.oAuthClientSecret')), 1),
                    _createElementVNode("div", _hoisted_28, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control w-full",
                        type: "text",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((subscriber.value.oAuthClientSecret) = $event))
                      }, null, 512), [
                        [_vModelText, subscriber.value.oAuthClientSecret]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (subscriber.value.authType === 'OAuth2')
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('webhook.oAuthScope')), 1),
                    _createElementVNode("div", _hoisted_31, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-control w-full",
                        type: "text",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((subscriber.value.oAuthScope) = $event))
                      }, null, 512), [
                        [_vModelText, subscriber.value.oAuthScope]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              (_unref(thereIsSubscriber))
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("button", {
                      class: "btn primary",
                      disabled: _ctx.savingSubscriber,
                      onClick: UpdateSubscriber
                    }, [
                      (!_ctx.savingSubscriber)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                            _hoisted_37,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('webhook.updateSubscriber')), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.$t('webhook.save')) + "...", 1))
                    ], 8, _hoisted_35)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("button", {
                      class: "btn primary",
                      disabled: _ctx.savingSubscriber,
                      onClick: createIfNotExisitSubscriber
                    }, [
                      (!_ctx.savingSubscriber)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                            _hoisted_42,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('webhook.createSubscriber')), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(_ctx.$t('webhook.save')) + "...", 1))
                    ], 8, _hoisted_40)
                  ]))
            ])
          ]),
          _hoisted_44,
          _withDirectives(_createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("h4", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('webhook.subscriptions')) + " ", 1),
                _createElementVNode("span", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("span", _hoisted_49, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t('webhook.subscriptionsInfoTitle')), 1),
                    _hoisted_50,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('webhook.subscriptionsInfo')), 1)
                  ])
                ])
              ])
            ]),
            _hoisted_51,
            (loadingSubs.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, _toDisplayString(_ctx.$t('global.loading')) + "... ", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  class: "primary mr-2",
                  onClick: openCreate
                }, _hoisted_56)), [
                  [_directive_permission, 'Webhook.Create']
                ]),
                _withDirectives((_openBlock(), _createElementBlock("button", {
                  disabled: !_unref(selectedSubscription).some(()=>true),
                  class: "primary mr-2",
                  onClick: deleteSelected
                }, _hoisted_59, 8, _hoisted_57)), [
                  [_directive_permission, 'Webhook.Delete']
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(GridInputFilter, {
                    gridStore: _unref(gridStore),
                    hideFilterButton: true
                  }, null, 8, ["gridStore"])
                ])
              ]),
              _createVNode(_unref(BryntumGrid), _mergeProps({
                ref_key: "grid",
                ref: grid
              }, gridConfig, { readOnly: true }), null, 16)
            ])
          ], 512), [
            [_vShow, _unref(thereIsSubscriber)]
          ])
        ]),
        (_unref(globalStore).modal.show && _unref(globalStore).modal.type === _unref(PopupType).WebhookNewSubscriptionPopup)
          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
              _createVNode(_component_WebhookNewSubscriptionPopup)
            ]))
          : _createCommentVNode("", true),
        (_unref(globalStore).modal.show && _unref(globalStore).modal.type === _unref(PopupType).WebhookUpdateSubscriptionPopup)
          ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
              _createVNode(_component_WebhookUpdateSubscriptionPopup)
            ]))
          : _createCommentVNode("", true)
      ], 512), [
        [_vShow, !_unref(globalStore).gridDataIsLoading]
      ])
    ], 512), [
      [_vShow, !_unref(globalStore).gridDataIsLoading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_63, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, _unref(globalStore).gridDataIsLoading]
    ]),
    (ctxMenu.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "ctx-menu",
          style: _normalizeStyle({ top: ctxMenu.y + 'px', left: ctxMenu.x + 'px' }),
          role: "menu",
          onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("button", {
            class: "ctx-item",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (openEdit(ctxMenu.rowId!)))
          }, _toDisplayString(_ctx.$t('webhook.edit')), 1),
          _createElementVNode("button", {
            class: "ctx-item danger",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (removeSubscription(ctxMenu.rowId!)))
          }, _toDisplayString(_ctx.$t('webhook.deleteSubscription')), 1)
        ], 4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})